import { render, staticRenderFns } from "./PosterLayout.vue?vue&type=template&id=691e544e&scoped=true"
import script from "./PosterLayout.vue?vue&type=script&lang=js"
export * from "./PosterLayout.vue?vue&type=script&lang=js"
import style0 from "./PosterLayout.vue?vue&type=style&index=0&id=691e544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691e544e",
  null
  
)

export default component.exports